export type VenueListing = {
  slug: string;
  name: string;
  city: string;
  country: string;
  musicGenres: string[];
};

export function venueSearchText(value: string): string {
  return value.normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase().trim();
}
